import './OrderMultiShip.scss';
import Component from './OrderMultiShip.js';
export default Component;
